Livewire.on('showAlert', () => {

    setTimeout( () => {
        const alert = document.querySelector('#livewire-alert')
        console.log(alert)
        alert.remove()
    }, 2000)
})

Livewire.on('setSelectQueryAutoFocus', (name) => {
    wraper = document.getElementById('search-wraper-'+name);
    if (wraper) {
        input = wraper.getElementsByClassName("input")[0];
        input.focus();
    }

})
